var _rect, _rect2, _rect3, _rect4, _rect5, _circle, _circle2, _circle3, _circle4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMenu(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 10,
    width: 100,
    height: 100,
    rx: 20,
    fill: "#f4f6f8"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 30,
    width: 60,
    height: 8,
    rx: 4,
    fill: "#4CAF50"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 50,
    width: 60,
    height: 8,
    rx: 4,
    fill: "#2196F3"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 70,
    width: 60,
    height: 8,
    rx: 4,
    fill: "#FFC107"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 90,
    width: 60,
    height: 8,
    rx: 4,
    fill: "#9C27B0"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 34,
    r: 4,
    fill: "#4CAF50"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 54,
    r: 4,
    fill: "#2196F3"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 74,
    r: 4,
    fill: "#FFC107"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 94,
    r: 4,
    fill: "#9C27B0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.e2ae23d66fac494b9d9bb22e89f5ae79.svg";
export { ForwardRef as ReactComponent };